import React from 'react';
// TODO: need to check the translation from POEditor for aria label
export function NewEpisodeBadge({ className, message }: { className?: string; message: string }) {
  return (
    <div role='status' aria-label='New Episode Badge' data-type='newEpisodeBadge' className={className}>
      {message}
    </div>
  );
}
